import React from 'react';
import * as Yup from 'yup';
import { Box } from '@mui/material';
import { Formik } from 'formik';
import { CheckboxWithLabel, SubmitButton } from '@uplift/ui-v2';


const validationSchema = Yup.object().shape({
  agree: Yup.boolean().oneOf([ true ], 'You must agree to sign the agreement'),
});


export const AgreementSigningForm: React.FC<{
  consentLabel: string;
  submitLabel?: string;
  onSubmit: () => Promise<void>;
}> = ({ consentLabel, submitLabel = 'Sign agreement', onSubmit, children }) => {
  return (
    <Formik initialValues={{ agree: false }} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ values }) => (
        <>
          {children}
          <CheckboxWithLabel showError name="agree" label={consentLabel} />
          <Box>
            <SubmitButton disabled={!values.agree}>{submitLabel}</SubmitButton>
          </Box>
        </>
      )}
    </Formik>
  );
};
